// School Photos
import berkeleyPhoto from "../assets/school-photos/berkeley.jpg";
import creeksidePhoto from "../assets/school-photos/creekside.jpg";
import eppersonPhoto from "../assets/school-photos/epperson.jpg";
import tapestryPhoto from "../assets/school-photos/tapestry.jpg";
import wellenParkPhoto from "../assets/school-photos/wellen-park.jpg";
import winthropPhoto from "../assets/school-photos/winthrop.jpg";
import settlementPhoto from "../assets/school-photos/settlement.jpg";
import {LocationStickyProps} from "../pages/OurSchools";

export const locationsByState: Record<string, LocationStickyProps[]> = {
    "florida": [
        {
            schoolKey: 'prodigy-creekside',
            name: "Prodigy at Creekside",
            address1: "14044 US-301 South",
            address2: "Riverview, FL 33578",
            phone: "(813) 381-5985",
            email: "creekside@prodigylearn.com",
            photo: creeksidePhoto,
            grades: ["Infant", "Toddler", "Pre-K", "VPK", "First Grade", "Second Grade", "Third Grade"],
            tourSchedulingEnabled: true,
            latitude: 27.7712268,
            longitude: -82.3338388
        },
        {
            schoolKey: 'prodigy-epperson',
            name: "Prodigy at Epperson",
            address1: "7772 Avery Scope View",
            address2: "Wesley Chapel, FL 33545",
            phone: "(813) 733-0515",
            email: "epperson@prodigylearn.com",
            photo: eppersonPhoto,
            grades: ["Infant", "Toddler", "Pre-K", "VPK", "First Grade", "Second Grade", "Third Grade"],
            tourSchedulingEnabled: true,
            latitude: 28.270748,
            longitude: -82.279004
        },
        {
            schoolKey: 'prodigy-sarasota',
            name: "Prodigy at Sarasota",
            address1: "8763 Fruitville Rd",
            address2: "Sarasota, FL 34240",
            phone: "941-306-1618",
            email: "sarasota@prodigylearn.com",
            grades: ["Infant", "Toddler", "Pre-K", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 27.3384644,
            longitude: -82.3955505
        },
        {
            schoolKey: 'prodigy-tapestry',
            name: "Prodigy at Tapestry",
            address1: "2410 W Carroll St",
            address2: "Kissimmee, FL 34741",
            phone: "(407) 749-6328",
            email: "tapestry@prodigylearn.com",
            photo: tapestryPhoto,
            grades: ["Infant", "Toddler", "Pre-K", "VPK", "First Grade", "Second Grade", "Third Grade"],
            tourSchedulingEnabled: true,
            latitude: 28.3228411,
            longitude: -81.4270071
        },
        {
            schoolKey: 'prodigy-treaty-oaks',
            name: "Prodigy at Treaty Oaks",
            address1: "1535 Brinkhoff Rd",
            address2: "St Augustine, FL 32086",
            phone: "(904) 687-0024",
            email: "treatyoaks@prodigylearn.com",
            grades: ["Infant", "Toddler", "Pre-K", "VPK", "First Grade", "Second Grade", "Third Grade"],
            tourSchedulingEnabled: true,
            latitude: 29.8362711,
            longitude: -81.3627956
        },
        {
            schoolKey: 'prodigy-winthrop',
            name: "Prodigy at Winthrop",
            address1: "6390 Scholars Hill Ln",
            address2: "Riverview, FL 33578",
            phone: "(813) 565-8366",
            email: "winthrop@prodigylearn.com",
            photo: winthropPhoto,
            grades: ["Infant", "Toddler", "Pre-K", "VPK", "First Grade", "Second Grade", "Third Grade"],
            tourSchedulingEnabled: true,
            latitude: 27.8886842,
            longitude: -82.31751229999999
        },
        {
            schoolKey: 'prodigy-wellen-park',
            name: "Prodigy at Wellen Park",
            address1: "11511 Mezzo Drive",
            address2: "Venice, FL 34293",
            phone: "(941) 263-5771",
            email: "wellenpark@prodigylearn.com",
            photo: wellenParkPhoto,
            grades: ["Infant", "Toddler", "Pre-K", "VPK", "First Grade", "Second Grade", "Third Grade"],
            tourSchedulingEnabled: true,
            latitude: 27.0424541,
            longitude: -82.3128917
        },
        {
            schoolKey: 'prodigy-wellington',
            name: "Prodigy at Wellington",
            address1: "5415 Morning Mist Way",
            address2: "Lake Worth, FL 33449",
            phone: "(561) 966-2646",
            email: "wellington@prodigylearn.com",
            grades: ["Infant", "Toddler", "Pre-K", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 26.6000336,
            longitude: -80.2044547
        },
    ],
    "florida csusa pk": [
        {
            schoolKey: 'prodigy-baymeadows',
            name: "Prodigy ELC at Baymeadows",
            address1: "7510 Baymeadows Way",
            address2: "Jacksonville, FL 32256",
            phone: "",
            email: "baymeadows@prodigylearn.com",
            microSchool: true,
            grades: ["PK", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 30.2318701,
            longitude: -81.5853471,
            customTourUrl: "https://www.baymeadowscharter.org/apps/forms2/?f=8299"
        },
        {
            schoolKey: 'prodigy-bonitasprings',
            name: "Prodigy ELC at Bonita Springs",
            address1: "25380 Bernwood Drive",
            address2: "Bonita Springs, FL 34135",
            phone: "",
            email: "bonitasprings@prodigylearn.com",
            microSchool: true,
            grades: ["PK", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 26.3653185,
            longitude: -81.7990575,
            customTourUrl: "https://www.bonitaspringscharter.org/enroll/tours.jsp"
        },
        {
            schoolKey: 'prodigy-centralpalm',
            name: "Prodigy ELC at Central Palm",
            address1: "6696 S Military Trl",
            address2: "Lake Worth Beach, FL 33463",
            phone: "",
            email: "centralpalm@prodigylearn.com",
            microSchool: true,
            grades: ["PK", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 26.5761315,
            longitude: -80.1115129,
            customTourUrl: "https://www.centralpalmcharter.org/apps/pages/index.jsp?uREC_ID=420165&type=d"
        },
        {
            schoolKey: 'prodigy-cherrylake',
            name: "Prodigy ELC at Cherry Lake",
            address1: "119 Wilson Lake Parkway",
            address2: "Groveland, FL 34736",
            phone: "",
            email: "cherrylake@prodigylearn.com",
            microSchool: true,
            grades: ["PK", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 28.604412,
            longitude: -81.796682,
            customTourUrl: "https://www.cherrylakeprep.org/apps/pages/?type=d&uREC_ID=615756&pREC_ID=1181197"
        },
        {
            schoolKey: 'prodigy-chickasaw',
            name: "Prodigy ELC at Chickasaw",
            address1: "8203 Valencia College Lane",
            address2: "Orlando, FL 32825",
            phone: "",
            email: "chickasaw@prodigylearn.com",
            microSchool: true,
            grades: ["PK", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 28.5550506,
            longitude: -81.2763346,
            customTourUrl: "https://www.chickasawcharter.org/apps/pages/index.jsp?uREC_ID=433601&type=d&pREC_ID=987759"
        },
        {
            schoolKey: 'prodigy-clay',
            name: "Prodigy ELC at Clay",
            address1: "1417 Red Apple Rd",
            address2: "Middleburg, FL 32068",
            phone: "",
            email: "clay@prodigylearn.com",
            microSchool: true,
            grades: ["PK", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 30.1234756,
            longitude: -81.8597724,
            customTourUrl: "https://www.claycharter.org/apps/pages/index.jsp?uREC_ID=379904&type=d&pREC_ID=987715"
        },
        {
            schoolKey: 'prodigy-cypress',
            name: "Prodigy ELC at Cypress",
            address1: "8151 Okeechobee Blvd",
            address2: "West Palm Beach, FL 33411",
            phone: "",
            email: "cypress@prodigylearn.com",
            microSchool: true,
            grades: ["PK", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 26.709059,
            longitude: -80.1713909,
            customTourUrl: "https://www.cypresscharter.org/apps/pages/index.jsp?uREC_ID=362963&type=d&pREC_ID=993411"
        },
        {
            schoolKey: 'prodigy-dmcs',
            name: "Prodigy ELC at DMCS",
            address1: "305 NW 3rd Avenue",
            address2: "Miami, FL 33128",
            phone: "",
            email: "dmcs@prodigylearn.com",
            microSchool: true,
            grades: ["PK", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 25.7773366,
            longitude: -80.1992751,
            customTourUrl: "https://www.downtowncharter.org/apps/pages/index.jsp?type=d&uREC_ID=421117&pREC_ID=1197468"
        },
        {
            schoolKey: 'prodigy-flagler',
            name: "Prodigy ELC at Flagler",
            address1: "12755 Flagler Center Blvd",
            address2: "Jacksonville, FL 32258",
            phone: "",
            email: "flagler@prodigylearn.com",
            microSchool: true,
            grades: ["PK", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 30.138623,
            longitude: -81.5169497,
            customTourUrl: "https://flaglercharter.org/apps/pages/index.jsp?uREC_ID=572608&type=d"
        },
        {
            schoolKey: 'prodigy-inprep-naples',
            name: "Prodigy ELC at InPrep Naples",
            address1: "12101 Immokalee Rd",
            address2: "Naples, FL 34120",
            phone: "",
            email: "inprepnaples@prodigylearn.com",
            microSchool: true,
            grades: ["PK", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 26.276518,
            longitude: -81.6242745,
            customTourUrl: "https://www.inprepnaples.org/apps/pages/index.jsp?uREC_ID=384506&type=d&termREC_ID=&pREC_ID=1039045"
        },
        {
            schoolKey: 'prodigy-inprep-sfm',
            name: "Prodigy ELC at InPrep of South Fort Myers",
            address1: "6851 Lancer Ave",
            address2: "Fort Myers, FL 33912",
            phone: "",
            email: "inprepsfm@prodigylearn.com",
            microSchool: true,
            grades: ["PK", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 26.5412599,
            longitude: -81.8442133,
            customTourUrl: "https://www.inprepsfm.org/apps/pages/index.jsp?type=d&uREC_ID=376972&pREC_ID=987690"
        },
        {
            schoolKey: 'prodigy-keysgate',
            name: "Prodigy ELC at Keys Gate",
            address1: "2000 SE 28 Avenue",
            address2: "Homestead, FL 33035",
            phone: "",
            email: "keysgate@prodigylearn.com",
            microSchool: true,
            grades: ["PK", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 25.4514801,
            longitude: -80.4350126,
            customTourUrl: "https://www.keyscharter.org/apps/pages/index.jsp?type=d&uREC_ID=420706&pREC_ID=993466"
        },
        {
            schoolKey: 'prodigy-lakewood-ranch',
            name: "Prodigy ELC at Lakewood Ranch",
            address1: "5550 White Eagle Blvd",
            address2: "Lakewood Ranch, FL 34211",
            phone: "",
            email: "lakewoodranch@prodigylearn.com",
            microSchool: true,
            grades: ["PK", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 27.440349,
            longitude: -82.4145032,
            customTourUrl: "https://lowerschool.lakewoodranch-prep.org/apps/pages/index.jsp?uREC_ID=520669&type=d&termREC_ID=&pREC_ID=998946"
        },
        {
            schoolKey: 'prodigy-mandarin',
            name: "Prodigy ELC at Mandarin",
            address1: "5209 Shad Rd",
            address2: "Jacksonville, FL 32257",
            phone: "",
            email: "mandarin@prodigylearn.com",
            microSchool: true,
            grades: ["PK", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 30.1939329,
            longitude: -81.5800846,
            customTourUrl: "https://www.mandarincharter.org/apps/pages/index.jsp?uREC_ID=400927&type=d&termREC_ID=&pREC_ID=1132211"
        },
        {
            schoolKey: 'prodigy-manatee',
            name: "Prodigy ELC at Manatee",
            address1: "4550 30th Street E",
            address2: "Bradenton, FL 34203",
            phone: "",
            email: "manatee@prodigylearn.com",
            microSchool: true,
            grades: ["PK", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 27.4596144,
            longitude: -82.526947,
            customTourUrl: "https://www.manateecharter.org/apps/pages/?type=d&uREC_ID=383329&pREC_ID=718346"
        },
        {
            schoolKey: 'prodigy-pines',
            name: "Prodigy ELC at Pines",
            address1: "10501 Pines Blvd",
            address2: "Pembroke Pines, FL 33026",
            phone: "",
            email: "pines@prodigylearn.com",
            microSchool: true,
            grades: ["PK", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 26.0091291,
            longitude: -80.2863801,
            customTourUrl: "https://www.recspines.org/apps/pages/index.jsp?uREC_ID=431947&type=d&termREC_ID=&pREC_ID=993473"
        },
        {
            schoolKey: 'prodigy-plantation',
            name: "Prodigy ELC at Plantation",
            address1: "6701 W Sunrise Blvd",
            address2: "Plantation, FL 33313",
            phone: "",
            email: "plantation@prodigylearn.com",
            microSchool: true,
            grades: ["PK", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 26.1391703,
            longitude: -80.2378645,
            customTourUrl: "https://www.plantationcharter.org/apps/pages/index.jsp?uREC_ID=444006&type=d&termREC_ID=&pREC_ID=993569"
        },
        {
            schoolKey: 'prodigy-poinciana',
            name: "Prodigy ELC at Poinciana",
            address1: "5125 Robert McLane Blvd",
            address2: "Kissimmee, FL 34758",
            phone: "",
            email: "poinciana@prodigylearn.com",
            microSchool: true,
            grades: ["PK", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 28.2525549,
            longitude: -81.4896868,
            customTourUrl: "https://www.poincianacharter.org/apps/pages/index.jsp?uREC_ID=374952&type=d&termREC_ID=&pREC_ID=987801"
        },
        {
            schoolKey: 'prodigy-raas',
            name: "Prodigy ELC at RAAS",
            address1: "4480 Boggy Creek Rd",
            address2: "Kissimmee, FL 34744",
            phone: "",
            email: "raas@prodigylearn.com",
            microSchool: true,
            grades: ["PK", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 28.3460032,
            longitude: -81.2622023,
            customTourUrl: "https://home.recsartsandsciences.org/apps/pages/index.jsp?uREC_ID=381085&type=d&pREC_ID=987756"
        },
        {
            schoolKey: 'prodigy-scholars',
            name: "Prodigy ELC at Scholars Academy",
            address1: "100 Scholars Way",
            address2: "Jacksonville, FL 32216",
            phone: "",
            email: "scholar@prodigylearn.com",
            microSchool: true,
            grades: ["PK", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 30.3122248,
            longitude: -81.5758006,
            customTourUrl: "https://duvalcharter.org/apps/pages/index.jsp?uREC_ID=393854&type=d&pREC_ID=987719"
        },
        {
            schoolKey: 'prodigy-southside',
            name: "Prodigy ELC at Southside",
            address1: "8680 AC Skinner Parkway",
            address2: "Jacksonville, FL 32256",
            phone: "",
            email: "southside@prodigylearn.com",
            microSchool: true,
            grades: ["PK", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 30.2463916,
            longitude: -81.5551863,
            customTourUrl: "https://www.southsidecharter.org/apps/pages/index.jsp?uREC_ID=398198&type=d&pREC_ID=987726"
        },
        {
            schoolKey: 'prodigy-summit',
            name: "Prodigy ELC at Summit",
            address1: "2001 Summit Blvd",
            address2: "West Palm Beach, FL 33406",
            phone: "",
            email: "summit@prodigylearn.com",
            microSchool: true,
            grades: ["PK", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 26.6674121,
            longitude: -80.0720133,
            customTourUrl: "https://www.recssummit.org/apps/pages/index.jsp?uREC_ID=431586&type=d&pREC_ID=993430"
        },
        {
            schoolKey: 'prodigy-tradition',
            name: "Prodigy ELC at Tradition",
            address1: "10900 SW Tradition Pkwy",
            address2: "Port St Lucie, FL 34987",
            phone: "",
            email: "tradition@prodigylearn.com",
            microSchool: true,
            grades: ["PK", "VPK"],
            tourSchedulingEnabled: false,
            latitude: 27.2666334,
            longitude: -80.4577165
        },
        {
            schoolKey: 'prodigy-westside',
            name: "Prodigy ELC at Westside",
            address1: "9238 103rd Street",
            address2: "Jacksonville, FL 32210",
            phone: "",
            email: "westside@prodigylearn.com",
            microSchool: true,
            grades: ["PK", "VPK"],
            tourSchedulingEnabled: true,
            latitude: 30.2466109,
            longitude: -81.8075026,
            customTourUrl: "https://westsidecharter.org/apps/pages/index.jsp?uREC_ID=432661&type=d&pREC_ID=987709"
        },
    ],

    "louisiana": [
        {
            schoolKey: 'prodigy-acadiana',
            name: "Prodigy at Acadiana",
            address1: "2520 Chemin Metairie Parkway",
            address2: "Youngsville, LA 70592",
            phone: "(337) 399-0064",
            email: "acadiana@prodigylearn.com",
            grades: ["Infant", "One Year Old", "Two Year Old", "Three Year Old", "Pre-K"],
            tourSchedulingEnabled: true,
            latitude: 30.0882227,
            longitude: -92.0004841
        },
        {
            schoolKey: 'plp-lafayette',
            name: "Prodigy at Lafayette",
            address1: "7659 Johnston Street",
            address2: "Lafayette, LA 70555",
            phone: "(337) 989-5055",
            email: "lafayette@prodigylearn.com",
            grades: ["Infant", "One Year Old", "Two Year Old", "Three Year Old", "Pre-K"],
            tourSchedulingEnabled: true,
            latitude: 30.1265890,
            longitude: -92.1137990
        },
        {
            schoolKey: 'plp-smp',
            name: "Prodigy at Sugar Mill Pond",
            address1: "104 Barbados Dr.",
            address2: "Youngsville, LA 70592",
            phone: "(337) 573-4284",
            email: "sugarmillpond@prodigylearn.com",
            grades: ["Infant", "One Year Old", "Two Year Old", "Three Year Old", "Pre-K"],
            tourSchedulingEnabled: true,
            latitude: 30.1074300,
            longitude: -92.0117360
        },
        {
            schoolKey: 'plp-youngsville',
            name: "Prodigy at Youngsville",
            address1: "619 Lafayette Street",
            address2: "Youngsville, LA 70592",
            phone: "(337) 451-4739",
            email: "youngsville@prodigylearn.com",
            grades: ["Infant", "One Year Old", "Two Year Old", "Three Year Old", "Pre-K"],
            tourSchedulingEnabled: true,
            latitude: 30.1077890,
            longitude: -91.9910470
        }


    ],
    "carolinas": [
        {
            schoolKey: 'prodigy-berkeley',
            name: "Prodigy at Berkeley",
            address1: "106 Bee Tree Blvd",
            address2: "Summerville, SC 29486",
            phone: "(843) 970-3382",
            email: "berkeley@prodigylearn.com",
            photo: berkeleyPhoto,
            grades: ["Infant", "Toddler", "Primary"],
            tourSchedulingEnabled: true,
            latitude: 33.146459,
            longitude: -80.1293139
        },
        {
            schoolKey: 'prodigy-lake-norman',
            name: "Prodigy at Lake Norman",
            address1: "171 West Waterlyn Road",
            address2: "Mooresville, NC 28117",
            phone: "",
            email: "",
            grades: ["Infant", "Toddler", "Pre-K", "First Grade", "Second Grade", "Third Grade"],
            tourSchedulingEnabled: false,
            latitude: 35.5626755,
            longitude: -80.85556
        },
        {
            schoolKey: 'prodigy-myrtle-beach',
            name: "Prodigy at Myrtle Beach",
            address1: "3790 SC-90",
            address2: "Conway, SC 29526",
            phone: "",
            email: "",
            grades: ["Infant", "Toddler", "Pre-K", "First Grade", "Second Grade", "Third Grade"],
            tourSchedulingEnabled: false,
            latitude: 33.8217351,
            longitude: -78.9036876
        },
        {
            schoolKey: 'prodigy-settlement',
            name: "Prodigy at the Settlement",
            address1: "113 Lewes Ave",
            address2: "Simpsonville, SC 29681",
            phone: "(864) 881-3550",
            email: "thesettlement@prodigylearn.com",
            photo: settlementPhoto,
            grades: ["Infant", "Toddler", "Pre-K", "First Grade", "Second Grade", "Third Grade"],
            tourSchedulingEnabled: true,
            latitude: 34.7344508,
            longitude: -82.2254966
        },
    ],

};
